export default __webpack_public_path__ + "static/media/customer.45012334.svg";